import { render, staticRenderFns } from "./EvaluacionDocentePage.vue?vue&type=template&id=4ce5b60e&scoped=true&"
import script from "./EvaluacionDocentePage.vue?vue&type=script&lang=js&"
export * from "./EvaluacionDocentePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5b60e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/EvaluacionDocentePage.vue
// module id = 200
// module chunks = 29